import {last} from 'rambda'

/**
 * Ads
 *
 * Handles all specific advertisement based hacks and solutions for BSS and MYT including:
 * - [data-size] - Provides the smallest acceptable size that the ad fits into
 * - [data-real-size] - Provides the actual size of the ad, regardless of what it should be
 * - TODO: DOM removal responsive ads that don't apply to the user (Currently in fragment)
 * - TODO: Maybe also some kind of custom event for when all ads are fully loaded?
 * */
export default function Ads() {
  const $body = document.querySelector("body");

  // First we will just observe the body for .adcore to appear
  const adsReadyObserver = new MutationObserver((mutations) => {
    // Once present, we know ads are actually going to load
    const adCorePresent = mutations[0].target.classList.contains("adcore");
    if (!adCorePresent) { return; }

    // Hook Mutation events onto all ad-blocks to listen for their specific ready states
    [...document.querySelectorAll(".ad-block")].map(watchAd);
    adsReadyObserver.disconnect();
  });
  adsReadyObserver.observe($body, { attributeFilter: ["class"] });
}

//           watchAd :: DOMElement -> void
export const watchAd = (ad) => {

  // Our observer is using a setTimeout(.., 1) to allow us to arrive right after
  // the page as been redrawn to accomidate the ad's potentional new size
  const observer = new MutationObserver(() => setTimeout(() => {
    // Get the width/height ideally from the inner element to get a more accurate
    // number without our own padding/margins being applied.
    const { clientHeight: height, clientWidth: width } = ad.firstChild || ad;
    const realSize = `${width}x${height}`
    const bestFit = getAcceptableSize(ad.getAttribute('data-ad-size') || "")(realSize)

    // Apply the best fit and the real size attributes
    ad.setAttribute('data-real-size', realSize);
    ad.setAttribute('data-size', bestFit)
    observer.disconnect();

    // 3rd party lazy loaded ads.
    //
    // Some ads are liars, google will tell us it's a halfpage slot with an MREC
    // sizing (300x250) but then the 3rd party code will then notice it's a halfpage
    // slot and apply styles to make itself takeup that space.
    //
    // We solve this by re-listening for any changes to the style attribute on the
    // main iframe and making sure to re-inspect the element if it tries to resize.
    const $iframe = ad.querySelector('iframe')
    if(!$iframe){ return }
    observer.observe($iframe, { attributeFilter: ["style"] })
  }), 1);

  // By observing data-google-query-id, we know that once it is set that google has finished
  // initialising the ad slot
  observer.observe(ad, { attributeFilter: ["data-google-query-id"] });
};

const parseSize = s => s.split('x').map(i => parseInt(i))

//           getAcceptableSize :: String -> String -> String
// @TODO: Add unit tests
export const getAcceptableSize = (sizes) => {
  // Sorted by total size
  //    acceptedSizes :: String -> Array of Pair<Int, Int>
  const acceptedSizes = (sizes || '')
        .split(',')
        .map(parseSize)
        .sort((a,b) => (a[0]*a[1]) - (b[0]*b[1]) )
  return (size) => {
    size = parseSize(size)
    for(const accept of acceptedSizes){
      if( accept[0] >= size[0] && accept[1] >= size[1] ){
        // Fits into the acceptable size
        return `${accept[0]}x${accept[1]}`
      }
    }
    // Nothing fit, return the largest result
    return last(acceptedSizes)
  }
}
